var _defs, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngagementLikely(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.605646,
    height: 25,
    viewBox: "0 0 17.605646 25",
    fill: "none",
    id: "svg172",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs176"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    rx: 1.5,
    fill: "#78d2f1",
    id: "rect170",
    x: 4.8751225,
    y: 10.00123
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g289",
    transform: "translate(0.00657352,15.00123)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1.5,
    fill: "#78d2f1",
    id: "rect280",
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g316",
    transform: "translate(9.7436718,5.0012289)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 20,
    rx: 1.5,
    fill: "#78d2f1",
    id: "rect307",
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#102835",
      fillOpacity: 1
    },
    id: "g335",
    transform: "translate(14.612221,0.00122903)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 25,
    rx: 1.5,
    fill: "#78d2f1",
    id: "rect326",
    x: 0,
    y: 0,
    style: {
      fill: "#102835",
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementLikely);
export default __webpack_public_path__ + "static/media/engagement_likely.a4d71bad7e95079089703b1947dbf70d.svg";
export { ForwardRef as ReactComponent };